import React from 'react';

export const AddEmptyIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" focusable="false" aria-hidden="true">
    <path d="M17 15V8h-2v7H8v2h7v7h2v-7h7v-2h-7z" fill="currentColor" />
  </svg>
);
